import React from 'react'
import styled from 'styled-components'
import { getExpConfig } from '../configService'
import { SPLIT_FEATURES } from '.'
import Text from '../../components/Text'
import format from 'date-fns/format'
import { getDcFreeTrialEligibility } from '../../lib/loyaltyFetch'

const TermsDiv = styled.div`
  margin-top: 1.5rem;
`
const TermsRedirectText = styled(Text)`
  cursor: pointer;
`
const DigitalClubIcon = styled.img`
  margin-bottom: 0.1rem;
  width: 0.875rem;
`
export const getDcFreeTrialConfig = () => {
  return JSON.parse(getExpConfig(SPLIT_FEATURES.DC_FREE_TRIAL).config)
}

export const checkoutTnCLink = () => {
  return (
    <TermsDiv>
      <Text size="medium" color="#696969">
        By joining the FairPrice Digital Club, you agree to the{' '}
        <TermsRedirectText
          as="a"
          color="#1e5dc1"
          href="https://help.fairprice.com.sg/hc/en-us/articles/360049899272-FairPrice-Digital-Club-Terms-and-Conditions"
          target="_blank"
        >
          Terms and Conditions.
        </TermsRedirectText>{' '}
        Your membership automatically renews monthly until terminated. You also
        authorise us to charge the monthly fee to your debit or credit card on
        our record.
      </Text>
    </TermsDiv>
  )
}

export const checkoutTncHeader = isUserEligibleForFreeTrial => {
  return `You will automatically be charged ${
    isUserEligibleForFreeTrial
      ? 'once your 1-month trial ends'
      : '$9.99 monthly'
  }. 
  Cancel your subscription anytime in your Fairprice account > Digital Club.`
}

export const cancelMembershipSuccessPopupTitle = (
  membershipAccount,
  cancellationDate,
  hasMembershipEnded,
  dateFormat
) => {
  if (membershipAccount?.freetrial) {
    return 'Membership Cancelled'
  } else {
    return !hasMembershipEnded
      ? `Your FairPrice Digital Club membership will end on ${format(
          cancellationDate.slice(0, -1),
          dateFormat
        )}.`
      : 'Your FairPrice Digital Club membership has been cancelled.'
  }
}

export const getUserDcEligibility = async () => {
  let eligibility
  const packageId = getDcFreeTrialConfig().packageId
  const res =
    packageId && (await getDcFreeTrialEligibility({ ctx: null, id: packageId }))
  res.packages.forEach(pack => {
    if (pack.package_id === parseInt(packageId)) {
      eligibility = pack.eligibility
    }
  })
  return eligibility
}

export const checkoutServiceFooter = (
  digitalClubConfig,
  hasFairPriceSeller,
  memberServiceFeeText,
  isMemberEnabled,
  digitalServiceFeeSwitch,
  isB2BUser,
  digitalIngressionFlag
) => {
  return digitalIngressionFlag ? (
    <>
      <Text size="small" color="#696969">
        Free for{' '}
      </Text>
      <DigitalClubIcon
        alt="Digital Club"
        src={digitalClubConfig?.iconUrl}
        data-testid="member-service-fee-icon-cart"
      />
      <Text size="small" color="#333333" margin="0 0.25rem 0 0">
        {digitalClubConfig?.serviceFeeDCLabel}
      </Text>
      <Text size="small" color="#696969">
        member
      </Text>
    </>
  ) : (
    isMemberEnabled && digitalServiceFeeSwitch && !isB2BUser && (
      <>
        <DigitalClubIcon
          alt="Digital Club"
          src={digitalClubConfig?.iconUrl}
          data-testid="member-service-fee-icon-cart"
        />
        <Text size="small" color="#333333" margin="0 0.25rem 0 0">
          {digitalClubConfig?.serviceFeeDCLabel}
        </Text>
        <Text size="small" color="#696969">
          {hasFairPriceSeller ? memberServiceFeeText : 'members benefits'}
        </Text>
      </>
    )
  )
}
